<template>
  <div>
    <div class="comm_popup_wrap_large">
      <div class="comm_title_wrap">
        <h4>{{ $t('MSG_TIT_NODE_INFO') }}</h4>
      </div>
      <div class="comm_view_wrap">
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_NODE_RLT')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-5">
            <div class="comm_label">
              {{ setParamMappingInfo.nodeId }} →
              {{ setParamMappingInfo.relationNodeId }}
              ({{ setParamMappingInfo.relationNodeTypeName }})
            </div>
          </div>
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_DTSVC_ID')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-5">
            <div class="comm_label">
              {{ setParamMappingInfo.dataServiceId }}
            </div>
          </div>
        </div>
      </div>
      <div class="mrB30" />
      <div class="comm_title_wrap">
        <h4>{{ $t('MSG_TXT_PRMT_MAPPING') }}</h4>
      </div>
      <div class="comm_gridTop_wrap">
        <div class="btn_wrapL">
          <sui-button
            type="button"
            class="comm_btn_gridTop"
            @click="onClickRowDelete"
          >
            {{ $t('MSG_BTN_ROW_DEL') }}
          </sui-button>
          <sui-button
            type="button"
            class="comm_btn_gridTop"
            @click="onClickRowCancel"
          >
            {{ $t('MSG_BTN_CANCEL') }}
          </sui-button>
        </div>
      </div>
      <sui-grid
        ref="grid"
        :columns="gridColumns0"
        :dataset="'dsRelationNodeParam'"
        :hideHeader="true"
        :multiselect="true"
        :showDisplayCountControl="false"
      />
    </div>
    <div class="comm_btn_wrap mrR30">
      <sui-button
        type="button"
        class="comm_btn_border"
        @click="onClickCancel"
      >
        {{ $t('MSG_BTN_CANCEL') }}
      </sui-button>
      <sui-button
        type="button"
        class="comm_btn_solid"
        @click="onClickApply"
      >
        {{ $t('MSG_BTN_APPLY') }}
      </sui-button>
    </div>
  </div>
</template>
<script>
// eslint-disable-next-line import/no-unresolved
import BasePage from '~cm/components/BasePage';

export default {
  name: 'PGE_CMR_00003_P07', // eslint-disable-line vue/name-property-casing
  extends: BasePage,
  props: {
    pageId: {
      type: String,
      default: null,
    },
    workflowId: {
      type: String,
      default: null,
    },
    setParamMappingInfo: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      inBoundDVOList: [],
      localdata0: [],
      deleteWorkflowNodeRelationParamList: [],
      gridColumns0: [{
        text: this.$t('MSG_TXT_PRMT_ID'),
        datafield: 'paramId',
      }, {
        text: this.$t('MSG_TXT_PRMT_NM'),
        datafield: 'paramItemName',
      }, {
        text: this.$t('MSG_TXT_IN_DVO'),
        datafield: 'dvoName',
        createwidget: (row, column, value, htmlElement) => {
          const componentInstance = utils.getGridCellFactory().createCellSelect(row, column, value, htmlElement,
            {
              optionList: this.inBoundDVOList,
            },
            this.dsRelationNodeParam, this.$refs.grid);

          componentInstance.getComponentInstance().$on('select', event => {
            const rowIndex = componentInstance.getDatasetIndex();
            this.dvoSelectChange(rowIndex, event);
          });
        },
        initwidget(row, column, value, htmlElement) {
          utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
        },
      }, {
        text: this.$t('MSG_TXT_PRMT_MAPPING_VAL'),
        datafield: 'paramMappingValue',
        createwidget: (row, column, value, htmlElement) => {
          utils.getGridCellFactory().createCellTextField(row, column, value, htmlElement,
            {
              trim: true,
              checkDisabledFunction: this.checkDisabledFunction,
            },
            this.dsRelationNodeParam, this.$refs.grid);
        },
        initwidget(row, column, value, htmlElement) {
          utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
        },
      }],
    };
  },
  computed: {
    // 계산된 속성, date pickproperty로 사용가능
  },
  watch: {
    // data 변경시 특정 함수를 호출 해야 하는 경우(async 등)
  },
  datasets: [{
    id: 'dsRelationNodeParam',
    type: 'local',
    data: 'localdata0',
    datafields: [
      { type: 'string', name: 'nodeRelationParamUid', map: 'nodeRelationParamUid' },
      { type: 'string', name: 'nodeRelationUid', map: 'nodeRelationUid' },
      { type: 'string', name: 'dvoName', map: 'dvoName' },
      { type: 'string', name: 'paramId', map: 'paramId' },
      { type: 'string', name: 'paramMappingValue', map: 'paramMappingValue' },
      { type: 'string', name: 'paramItemName', map: 'paramItemName' },
      { type: 'string', name: 'nodeRelationParamMappingUid', map: 'nodeRelationParamMappingUid' },
    ],
  }],
  mounted() {
    this.$nextTick(() => {
      if (!utils.isEmpty(this.setParamMappingInfo)) {
        if (!utils.isUndefined(this.setParamMappingInfo.dataServiceId)
         && !utils.isEmpty(utils.trim(this.setParamMappingInfo.dataServiceId))) {
          this.setInboundDVOList();
        } else {
          this.setNodeRelationParam();
        }
      }
    });
  },
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    /**
     * InboundDVO selectBox OptionList 조회
     */
    setInboundDVOList() {
      http.request(this.pageId, 'DTS_CMR_00010', {
        path: {
          'data-service-id': this.setParamMappingInfo.dataServiceId,
        },
      }).then(res => {
        const inBoundDVOList = [];
        this.inBoundDVOList = [];

        utils.forEach(res.data, obj => {
          const option = {
            key: obj.code,
            label: obj.displayName,
          };
          inBoundDVOList.push(option);
        });
        this.inBoundDVOList = inBoundDVOList;

        if (utils.isUndefined(this.setParamMappingInfo.saveWorkflowNodeRelationParamList)
      || utils.isEmpty(this.setParamMappingInfo.saveWorkflowNodeRelationParamList)) {
          this.setNodeRelationParam();
        } else {
          const paramList = utils.clone(this.setParamMappingInfo.saveWorkflowNodeRelationParamList);
          this.dsRelationNodeParam.submit();
          this.dsRelationNodeParam.setRawData(paramList);
        }
      });
    },
    /**
     * 파라미터 목록 조회
     */
    setNodeRelationParam() {
      const queryParams = {
        workflowId: this.setParamMappingInfo.workflowId,
        nodeRelationUid: this.setParamMappingInfo.nodeRelationUid,
        relationNodeId: this.setParamMappingInfo.relationNodeId,
        ruleUid: this.setParamMappingInfo.ruleUid,
      };

      http.request(this.pageId, 'DTS_CMR_00040', {
        query: queryParams,
      }).then(res => {
        const paramList = utils.clone(res.data);
        // 노드 관계 '결재' 인 경우 '결재id' Param 추가
        // 기존 '결재id' param이 존재하는 경우 paramName 추가(결재ID같은 경우 Param정보를 참조하는 테이블이 없어서 화면에서 처리)
        const index = utils.findIndex(paramList, o => utils.isEqual(o.paramId, 'approvalId'));
        const approvalParam = {
          paramId: 'approvalId',
          paramItemName: this.$t('MSG_TXT_APRV_ID'),
        };

        if (utils.isEqual(this.setParamMappingInfo.relationNodeTypeCode, 'AP') && index < 0) {
          paramList.push(approvalParam);
        } else if (index > -1) {
          paramList[index].paramItemName = this.$t('MSG_TXT_APRV_ID');
        }

        this.dsRelationNodeParam.setRawData(paramList); // 데이터 셋에 데이터를 넣는 함수
      });
    },
    /**
     * Button Event
     */
    onClickCancel() {
      this.$emit('popupClose');
    },
    onClickApply() {
      if (!this.validationCheck()) return false;

      this.returnParam();
      this.$emit('popupClose');

      return null;
    },
    /**
     * 부모창으로 선택 된 data 전달.
     */
    returnParam() {
      const paramMappingInfo = {
        saveWorkflowNodeRelationParamList: utils.clone(this.dsRelationNodeParam.data),
        deleteWorkflowNodeRelationParamList: utils.clone(this.deleteWorkflowNodeRelationParamList),
      };
      this.$emit('paramReturn', paramMappingInfo, 'paramMappingInfo');
    },
    /**
     * InboundDVO 값에 따른 파라미터매핑값 입력 제한
     */
    dvoSelectChange(rowIndex, event) {
      if (utils.startsWith(event, 'entity')) {
        this.dsRelationNodeParam.setData(rowIndex, 'paramMappingValue', event);
      } else if (utils.startsWith(event, 'ResponseSize')) {
        this.dsRelationNodeParam.setData(rowIndex, 'paramMappingValue', 'size');
      } else {
        this.dsRelationNodeParam.setData(rowIndex, 'paramMappingValue', '');
      }
    },
    paramMappingValueDisabled(rowIndex) {
      const { dvoName } = this.dsRelationNodeParam.data[rowIndex];
      if (utils.isEmpty(dvoName)) return false;
      if (utils.startsWith(dvoName, 'entity') || utils.startsWith(dvoName, 'ResponseSize')) {
        return true;
      }
      return false;
    },
    /**
     * 입력 체크
     */
    validationCheck() {
      let flag = true;
      utils.forEach(this.dsRelationNodeParam.data, (obj, row) => {
        if (utils.isEmpty(obj.dvoName)) {
          utils.messageBox('warning', utils.strFormat(this.$t('MSG_ALT_ROW_INPUT'),
            row + 1,
            this.$t('MSG_TXT_IN_DVO')),
          null,
          () => {
            this.gridSetFocus(row, 'dvoName');
          });
          flag = false;
          return false;
        }
        if (utils.isEmpty(obj.paramMappingValue)) {
          utils.messageBox('warning', utils.strFormat(this.$t('MSG_ALT_ROW_INPUT'),
            row + 1,
            this.$t('MSG_TXT_PRMT_MAPPING_VAL')),
          null,
          () => {
            this.gridSetFocus(row, 'paramMappingValue');
          });
          flag = false;
          return false;
        }

        return null;
      });
      return flag;
    },
    gridSetFocus(rowIndex, datafield) {
      this.$refs.grid.$refs.grid.ensurerowvisible(rowIndex);

      const editor = this.$refs.grid.getCellEditor(rowIndex, datafield);

      if (editor) {
        editor.getComponentInstance().setFocus();
      }
    },
    /**
     * grid disabled Function
     */
    checkDisabledFunction(rowData) {
      const { dvoName } = rowData;
      if (utils.isEmpty(dvoName)) {
        return false;
      } if (utils.startsWith(dvoName, 'entity') || utils.startsWith(dvoName, 'ResponseSize')) {
        return true;
      }
      return false;
    },
    /**
     * 행 삭제
     */
    onClickRowDelete() {
      const selectedIndexes = this.dsRelationNodeParam.getSelectedIndexes();
      const gridOriginalList = utils.clone(this.dsRelationNodeParam.originalData);
      utils.forEach(selectedIndexes, index => {
        if (!utils.isEmpty(gridOriginalList[index].nodeRelationParamMappingUid)) {
          this.deleteWorkflowNodeRelationParamList.push(gridOriginalList[index]);
        }
      });
      this.dsRelationNodeParam.deleteRows(selectedIndexes);
    },
    /**
     * 취소 (grid row)
     */
    onClickRowCancel() {
      this.dsRelationNodeParam.submit();
      this.dsRelationNodeParam.setRawData(this.dsRelationNodeParam.originalData);
    },
  },
};
</script>
<style scoped>
</style>
